import { render, staticRenderFns } from "./CusInputItem.vue?vue&type=template&id=010b99dc&scoped=true&"
import script from "./CusInputItem.vue?vue&type=script&lang=js&"
export * from "./CusInputItem.vue?vue&type=script&lang=js&"
import style0 from "./CusInputItem.vue?vue&type=style&index=0&id=010b99dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010b99dc",
  null
  
)

export default component.exports